import { PRODUCTS } from "@/lib/products";
import { ProductCard } from "./ProductCard";
import { Reveal } from "./Reveal";

export function Collection() {
  return (
    <section id="collection" className="relative bg-[#281715] grain overflow-hidden py-24 lg:py-36" data-testid="collection-section">
      <div className="absolute left-1/2 top-0 -translate-x-1/2 w-[900px] h-[500px] bg-[radial-gradient(ellipse_at_top,rgba(235,177,182,0.18),transparent_70%)]" />
      <div className="relative max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-14">
        <Reveal className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-20">
          <div>
            <p className="overline text-[#EBB1B6]">The launch edit · three essentials</p>
            <h2 className="font-display text-[#FAF7F2] text-5xl sm:text-6xl lg:text-7xl mt-5 leading-[0.95]">
              Three lips. <span className="italic text-[#EBB1B6]">One glow.</span>
            </h2>
          </div>
          <p className="max-w-sm text-[#D9C4BC] leading-relaxed">
            We launch small on purpose: a gloss, an oil and a gift set, each in shades tested on a range of skin tones.
          </p>
        </Reveal>
        <div className="grid md:grid-cols-3 gap-16 md:gap-10 lg:gap-14">
          {PRODUCTS.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
        <Reveal className="mt-24">
          <div className="relative rounded-[32px] border border-[#EBB1B6]/30 bg-[#4A2E2B]/40 backdrop-blur-xl p-8 sm:p-10 flex flex-col md:flex-row md:items-center justify-between gap-6" data-testid="launch-bundle-banner">
            <div>
              <p className="overline text-[#EBB1B6]">Launch bundle</p>
              <p className="font-display text-[#FAF7F2] text-3xl sm:text-4xl mt-3 leading-tight">Buy two glosses, get <span className="italic text-[#EBB1B6]">50% off</span> a lip oil.</p>
              <p className="text-sm text-[#D9C4BC] mt-3">Applied automatically in your bag — no code needed.</p>
            </div>
            <div className="flex items-center gap-3 font-display text-[#FAF7F2]">
              <span className="text-2xl">2 × $14.99</span><span className="text-[#EBB1B6]">+</span>
              <span className="text-2xl"><span className="line-through text-[#D9C4BC] text-lg mr-2">$17.99</span>$9.00</span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
